import { AxiosResponse } from 'axios';

import { camelizeObject } from '@cvt/helpers/object';
import { request } from '@cvt/clients/baseClient';
import { mapFeedbackCrudData } from '@modules/Feedback/client/feedbackClient.formatter';


const apiBaseUrl = import.meta.env.VITE__CVT_API_URL;

const createFeedback = (data: Feedback.Create): Promise<AxiosResponse<Feedback.Feedback>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/feedback/`,
      method: 'POST',
      data: mapFeedbackCrudData(data as Feedback.Create),
    },
  }).then((data: AxiosResponse<Feedback.FeedbackApi>) => ({
    ...data,
    data: camelizeObject<Feedback.Feedback>(data.data),
  }));
};

const editFeedback = (data: Partial<Feedback.Edit>): Promise<AxiosResponse<Feedback.Feedback>> => {
  return request({
    options: {
      url: `${apiBaseUrl}/feedback/${data.id}/`,
      method: 'PUT',
      data: mapFeedbackCrudData(data),
    },
  });
};

export const feedbackClient = {
  createFeedback,
  editFeedback,
};
